import React, { useEffect, useState } from 'react';
import { Outlet, Link,  useParams  } from "react-router-dom";
import MainContainer from '../../parts/MainContainer';

import JobOrderInfo from './JobOrderInfo';
 
function JobOrderViewer (){
    let { service_id } = useParams();

    return (
        <MainContainer page_title="Job Order" menu="reports-job-order">
            <div className="container-fluid">
                <JobOrderInfo service_id={service_id} className="pb-3" />
            </div>
        </MainContainer>
    )
}
 
export default JobOrderViewer;